import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Fluxible } from 'fluxible';
import { FluxibleComponent } from 'fluxible-addons-react';
import OnlineStatusStore from 'contest/stores/online-status-store';
import { pollOnlineStatus } from 'contest/actions/online-status';
import ConnectedStatusIndicator from 'contest/components/connected/connected-status-indicator';

export default (node) => {
    const apiUrl = node.getAttribute('data-last-seen-time-url');
    const intlData = JSON.parse(node.getAttribute('data-last-seen-indicator-translation-map'));
    const user = JSON.parse(node.getAttribute('data-last-seen-time-user'));

    const app = new Fluxible({ stores: [OnlineStatusStore] });
    const context = app.createContext();

    context.executeAction(pollOnlineStatus, { apiUrl });

    ReactDOM.render(
        <IntlProvider locale={document.documentElement.lang} messages={intlData.messages}>
            <FluxibleComponent context={context.getComponentContext()}>
                <ConnectedStatusIndicator user={user} />
            </FluxibleComponent>
        </IntlProvider>,
        node
    );
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/online-status/init-indicator.js